import React from "react";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";
import { COLORS } from "../config/theme";
import ButtonComponent from "./ButtonComponent";
import { completarRequisito } from "../services/expediente.service";

export default function RequisitoRespuestaSiNoNoSabe({
  showNoSabe,
  setIsVisibleModal,
  setReload,
  reload,
  requisito,
}) {

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const onClose = () => {
    setIsVisibleModal(false);
    setValue("");
  };

  const getValue = (value) => {
    switch (value) {
      case "yes":
        return "SI";
        break;
      case "no":
        return "NO";
        break;
      case "no_sabe":
        return "NO SABE";
        break;            
      default:
        return "";
        break;
    }
  }

  const getKey = (value) => {
    switch (value) {
      case "SI":
        return "yes";
        break;
      case "NO":
        return "no";
        break;
      case "NO SABE":
        return "no_sabe";
        break;            
      default:
        return "";
        break;
    }
  }  

  const [value, setValue] = React.useState(getKey(requisito?.mov_respuesta_obs) || "");
  
  const completarRequisitoConRespuesta = async () => {
    const finalValue = getValue(value);
    try {
      const data = {
        id_mov: requisito.id_mov,
        mov_respuesta_obs: finalValue,
      };
      const result = await completarRequisito(data);

      if (result.data) {
        setReload(!reload);
        onClose();
      }
    } catch (error) {
      console.log("Failed to add selection", error);
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup row value={value} onChange={handleChange}>
            <FormControlLabel
              value="yes"
              control={<Radio color="primary" />}
              label="Sí"
            />
            <FormControlLabel
              value="no"
              control={<Radio color="primary" />}
              label="No"
            />
            {showNoSabe && (
              <FormControlLabel
                value="no_sabe"
                control={<Radio color="primary" />}
                label="No Sabe"
              />
            )}
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="space-between">
          <ButtonComponent
            name="Guardar"
            toAction={completarRequisitoConRespuesta}
            disabled={value === ""}
          />
          <div style={{ width: "5px" }}></div>
          <ButtonComponent
            name="Cancelar"
            toAction={onClose}
            color={COLORS.DANGER}
          />
        </Box>
      </Grid>
    </>
  );
}
